<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditEditChildActivityConfigDialog(true, null)"
      >新增子活动配置</el-button
    >
    <el-table :data="list" border size="small" style="width: 941px">
      <el-table-column prop="id" label="ID" align="center" width="150">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="type"
        label="类型"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="desc"
        label="描述"
        align="center"
        width="300"
      >
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="remark"
        label="备注"
        align="center"
        width="200"
      >
      </el-table-column>

      <!-- <el-table-column prop="parameter" label="参数" align="center" width="100">
        <template slot-scope="scope">
          <span
            class="link-button"
            @click="openChildActivityConfigParameterDialog(scope.row)"
            >查看</span
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="parameter" label="操作" align="center" width="140">
        <template slot-scope="scope">
          <span
            class="link-button"
            style="color: red"
            @click="remove(scope.row)"
            >删除</span
          >
          <span
            class="link-button"
            @click="openEditEditChildActivityConfigDialog(false, scope.row)"
            >编辑</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const yaml = require("js-yaml");

export default {
  data() {
    return {
      list: [], // 子活动配置列表
    };
  },

  created() {
    this.loadList();
  },

  components: {},

  methods: {
    /**
     * 拉取子活动配置集合
     */
    async loadList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAllChildActivityConfig`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = listInResponse;
    },

    /**
     * 删除
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除子活动配置（${entry.desc}）？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delChildActivityConfig`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (error) {}
    },

    /**
     * 打开查看参数弹窗
     */
    async openChildActivityConfigParameterDialog(entry) {
      this.$dialogutil.open("ChildActivityConfigParameterDialog", {
        closedCallback: () => {},
        data: { info: entry },
      });
    },

    /**
     * 打开查看参数弹窗
     */
    async openEditEditChildActivityConfigDialog(isCreated, entry) {
      this.$dialogutil.open("EditChildActivityConfigDialog", {
        closedCallback: async () => {
          await this.loadList();
        },
        data: { isCreated: isCreated, entry: entry },
      });
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    string2yaml(obj) {
      let yamlStr;
      yaml.loadAll(obj, function (doc) {
        yamlStr = yaml.dump(doc, {
          styles: {
            "!!null": "canonical",
          },
          sortKeys: true,
        });
      });
      return yamlStr;
    },
    formatCode(obj) {
      return JSON.stringify(obj, null, "    ");
    },
  },
};
</script>
  
<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>

 